import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Seo from "../components/Seo";

export default function Cookie() {
  return (
    <div className="min-h-screen">
      <Seo
        title="Cookie Policy"
        description="Quali cookie utilizziamo su BrickDailyDeals, perché e come gestirli. Cookie tecnici, analitici e di profilazione AdSense."
        path="/cookie"
      />
      <Header />
      <div className="max-w-3xl mx-auto px-6 py-16">
        <Link
          to="/"
          data-testid="cookie-back"
          className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white mb-8"
        >
          <ArrowLeft size={14} /> Home
        </Link>

        <div className="font-mono-bdd text-xs uppercase tracking-[0.3em] text-[#FBD51C] mb-3">
          Informativa
        </div>
        <h1 className="font-display font-black text-4xl text-white mb-8 tracking-tight">
          Cookie Policy
        </h1>

        <div className="space-y-5 text-zinc-300 text-sm leading-relaxed">
          <p className="text-zinc-500">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT")}</p>

          <p>
            Questo sito utilizza cookie e tecnologie analoghe per migliorare l&apos;esperienza di
            navigazione e per mostrare pubblicità. Di seguito i dettagli.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">1. Cosa sono i cookie</h2>
          <p>
            I cookie sono piccoli file di testo che il Sito invia al tuo dispositivo (computer,
            smartphone, tablet) dove vengono memorizzati per essere poi ritrasmessi al Sito alla
            successiva visita.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">2. Tipologie di cookie utilizzati</h2>

          <div className="border border-zinc-800 rounded-xl overflow-hidden mt-3">
            <table className="w-full text-sm">
              <thead className="bg-zinc-900 text-zinc-400 text-[11px] uppercase tracking-wider font-mono-bdd">
                <tr>
                  <th className="text-left px-4 py-3">Cookie</th>
                  <th className="text-left px-4 py-3">Tipo</th>
                  <th className="text-left px-4 py-3">Finalità</th>
                  <th className="text-left px-4 py-3">Durata</th>
                </tr>
              </thead>
              <tbody className="bg-zinc-950">
                <tr className="border-t border-zinc-800">
                  <td className="px-4 py-3 text-white">bdd_token</td>
                  <td className="px-4 py-3 text-zinc-400">Tecnico</td>
                  <td className="px-4 py-3 text-zinc-400">Sessione admin (solo per gli amministratori)</td>
                  <td className="px-4 py-3 text-zinc-400">7 giorni</td>
                </tr>
                <tr className="border-t border-zinc-800">
                  <td className="px-4 py-3 text-white">__gads / __gpi</td>
                  <td className="px-4 py-3 text-zinc-400">Pubblicitario (Google)</td>
                  <td className="px-4 py-3 text-zinc-400">Personalizzazione e misurazione annunci AdSense</td>
                  <td className="px-4 py-3 text-zinc-400">13 mesi</td>
                </tr>
                <tr className="border-t border-zinc-800">
                  <td className="px-4 py-3 text-white">IDE / NID</td>
                  <td className="px-4 py-3 text-zinc-400">Pubblicitario (Google)</td>
                  <td className="px-4 py-3 text-zinc-400">Profilazione pubblicitaria</td>
                  <td className="px-4 py-3 text-zinc-400">13 mesi</td>
                </tr>
                <tr className="border-t border-zinc-800">
                  <td className="px-4 py-3 text-white">_ga / _gid</td>
                  <td className="px-4 py-3 text-zinc-400">Analytics (Google)</td>
                  <td className="px-4 py-3 text-zinc-400">Statistiche di traffico (se Google Analytics è attivato)</td>
                  <td className="px-4 py-3 text-zinc-400">24 mesi</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h2 className="font-display text-2xl text-white mt-8">3. Cookie di terze parti</h2>
          <p>
            Il Sito incorpora servizi di terze parti che possono installare cookie autonomamente.
            Le rispettive informative sono disponibili ai seguenti link:
          </p>
          <ul className="list-disc list-inside space-y-1 ml-2">
            <li>
              <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer" className="text-[#FBD51C]">
                Google AdSense — Privacy & Termini
              </a>
            </li>
            <li>
              <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#FBD51C]">
                Google LLC — Norme sulla privacy
              </a>
            </li>
          </ul>

          <h2 className="font-display text-2xl text-white mt-8">4. Come gestire i cookie</h2>
          <p>
            Puoi accettare, rifiutare o cancellare i cookie in qualsiasi momento dalle impostazioni
            del tuo browser:
          </p>
          <ul className="list-disc list-inside space-y-1 ml-2">
            <li>
              <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-[#FBD51C]">Chrome</a>
            </li>
            <li>
              <a href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie" target="_blank" rel="noopener noreferrer" className="text-[#FBD51C]">Firefox</a>
            </li>
            <li>
              <a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-[#FBD51C]">Safari</a>
            </li>
            <li>
              <a href="https://support.microsoft.com/it-it/microsoft-edge" target="_blank" rel="noopener noreferrer" className="text-[#FBD51C]">Edge</a>
            </li>
          </ul>
          <p>
            Per disattivare la personalizzazione degli annunci di Google visita{" "}
            <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer" className="text-[#FBD51C]">
              adssettings.google.com
            </a>.
          </p>

          <h2 className="font-display text-2xl text-white mt-8">5. Consenso</h2>
          <p>
            Continuando a navigare sul Sito acconsenti all&apos;utilizzo dei cookie come descritto in questa
            informativa. Per maggiori dettagli sul trattamento dei dati, consulta la nostra{" "}
            <Link to="/privacy" className="text-[#FBD51C]">Privacy Policy</Link>.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
